import React, { useState, useEffect } from "react";
import { Navigate } from "react-router-dom";
import { doc, getDoc } from "firebase/firestore";
import { database } from "../Firebase";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { Spinner, Container } from "react-bootstrap";

export default function AdminRoute({ children }) {
  const [isAdmin, setIsAdmin]   = useState(null);
  const [loading, setLoading]   = useState(true);

  useEffect(() => {
    const auth = getAuth();

    // ── On attend que Firebase ait fini de charger la session ────────────────
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (!user) {
        // Pas connecté → pas admin
        setIsAdmin(false);
        setLoading(false);
        return;
      }

      try {
        const userSnap = await getDoc(doc(database, "users", user.uid));
        if (userSnap.exists() && userSnap.data().role === "admin") {
          setIsAdmin(true);
        } else {
          setIsAdmin(false);
        }
      } catch (err) {
        console.error("Erreur vérification admin:", err);
        setIsAdmin(false);
      } finally {
        setLoading(false);
      }
    });

    return () => unsubscribe();
  }, []);

  if (loading) {
    return (
      <Container className="py-5 text-center">
        <Spinner animation="border" style={{ color: "#07a993" }} />
        <p className="mt-2 text-muted">Vérification des droits...</p>
      </Container>
    );
  }

  if (!isAdmin) return <Navigate to="/" replace />;

  return children;
}